import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SpiritualCollection.css';
import rudrakshImg from '../Assets/Rudraksh.jpeg';
import blowingConchImg from '../Assets/conch(blowing).png';
import rightHandConchImg from '../Assets/rshank.jpg';
import shreefalImg from '../Assets/shreefall.jpg';

const SPIRITUAL_ITEMS = [
  {
    name: 'RUDRAKSH',
    label: 'Rudraksh',
    tag: 'Sacred Beads',
    subtitle: 'Sacred Beads of Lord Shiva',
    image: rudrakshImg,
    imageAlt: 'Rudraksh beads',
    gradient: 'linear-gradient(135deg, #5c2a0a 0%, #a0521e 45%, #c47a35 100%)',
    glow: 'rgba(196, 122, 53, 0.4)',
    tint: 'rgba(255, 214, 170, 0.22)',
  },
  {
    name: 'BLOWING COANCH (SHANKH)',
    label: 'Blowing Conch',
    tag: 'Temple Sound',
    subtitle: 'Shankh - Divine Sound',
    image: blowingConchImg,
    imageAlt: 'Blowing conch shell',
    gradient: 'linear-gradient(135deg, #1a3a2e 0%, #2d6b50 45%, #4a9e7a 100%)',
    glow: 'rgba(74, 158, 122, 0.4)',
    tint: 'rgba(198, 255, 228, 0.18)',
  },
  {
    name: 'RIGHT HAND COANCH (DAKSHINAVARTI)',
    label: 'Right-Hand Conch',
    tag: 'Rare Blessing',
    subtitle: 'Dakshinavarti Shankh - Rare and Auspicious',
    image: rightHandConchImg,
    imageAlt: 'Right-hand conch',
    gradient: 'linear-gradient(135deg, #1a1a4e 0%, #2e2e8a 45%, #5050c8 100%)',
    glow: 'rgba(80, 80, 200, 0.4)',
    tint: 'rgba(214, 216, 255, 0.2)',
  },
  {
    name: 'ONE EYE COCONUT (EKAKSHI SHREEFAL)',
    label: 'Ekakshi Shreefal',
    tag: 'Prosperity Symbol',
    subtitle: 'One Eye Coconut - Symbol of Prosperity',
    image: shreefalImg,
    imageAlt: 'Ekakshi shreefal coconut',
    gradient: 'linear-gradient(135deg, #1e3a1a 0%, #3a6b2d 45%, #5a9e48 100%)',
    glow: 'rgba(90, 158, 72, 0.4)',
    tint: 'rgba(229, 255, 188, 0.18)',
  },
];

const SpiritualCollection = () => {
  const navigate = useNavigate();

  return (
    <section className="sc-section">
      <div className="sc-bg-circle sc-bg-1" />
      <div className="sc-bg-circle sc-bg-2" />

      <div className="sc-inner">
        <div className="sc-header">
          <span className="sc-tag">Sacred and Divine</span>
          <h2 className="sc-heading">Spiritual Collection</h2>
          <p className="sc-desc">
            Discover our handpicked sacred treasures - each piece carrying divine energy,
            positive vibrations and centuries of spiritual significance.
          </p>
        </div>

        <div className="sc-grid">
          {SPIRITUAL_ITEMS.map((item) => (
            <div
              key={item.name}
              className="sc-banner-card"
              style={{
                background: item.gradient,
                '--glow': item.glow,
                '--card-tint': item.tint,
              }}
              onClick={() => navigate(`/store?material=${encodeURIComponent(item.name)}`)}
            >
              <div className="sc-ring sc-ring-1" />
              <div className="sc-ring sc-ring-2" />
              <div className="sc-card-shine" />
              <div className="sc-card-orbit" />

              <div className="sc-banner-media">
                <div className="sc-banner-aura" />
                <div className="sc-banner-image-wrap">
                  <img
                    src={item.image}
                    alt={item.imageAlt}
                    className="sc-banner-image"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="sc-banner-body">
                <span className="sc-banner-tag">{item.tag}</span>
                <h3 className="sc-banner-title">{item.label}</h3>
                <p className="sc-banner-sub">{item.subtitle}</p>
                <button className="sc-banner-btn" type="button">
                  Explore Collection
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SpiritualCollection;
